import { render, staticRenderFns } from "./InputElektronik.vue?vue&type=template&id=2b581f11&"
import script from "./InputElektronik.vue?vue&type=script&lang=js&"
export * from "./InputElektronik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports